import { render } from "./BaseMenu.vue?vue&type=template&id=816c378e"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"
script.render = render

export default script